import { render, staticRenderFns } from "./HandleDialog.vue?vue&type=template&id=a97bb67a&scoped=true&"
import script from "./HandleDialog.vue?vue&type=script&lang=js&"
export * from "./HandleDialog.vue?vue&type=script&lang=js&"
import style0 from "./HandleDialog.vue?vue&type=style&index=0&id=a97bb67a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a97bb67a",
  null
  
)

export default component.exports